var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[(_vm.src)?_c('img',{staticClass:"reduce-navigator-icon",attrs:{"src":_vm.src}}):(_vm.faIcon)?_c('font-awesome-icon',{staticClass:"reduce-navigator-icon",attrs:{"icon":['fad', _vm.faIcon]}}):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }